import { inject, injectable } from 'inversify';
import "reflect-metadata";
import { TYPES } from '../di/types';
import IAppConfig from '../config';
import Axios, { AxiosResponse } from "axios";

export interface IDossierApiClient {
    getDossiers(dto: PagedRequest<SearchModel>): Promise<AxiosResponse<PagedData<DossierDto>>>
    createDossier(dto: CreateDossierDto): Promise<AxiosResponse<number>>
    getCompanyAutofill(countryCode: string, vat: string): Promise<AxiosResponse<CompanyByVatNumber>>
    updateDossierStatus(dto: UpdateDossierStatus): Promise<AxiosResponse>
    exportToExcel(): Promise<AxiosResponse<string>>

}

@injectable()
export class DossierApiClient {
    @inject(TYPES.IAppConfig) private _config: IAppConfig;

    updateDossierStatus(dto: UpdateDossierStatus): Promise<AxiosResponse> {
        return Axios.post(`${this._config.endpointUrl}api/dossiers/UpdateDossierStatus`, dto);
    }
    getDossiers(dto: PagedRequest<SearchModel>): Promise<AxiosResponse<PagedData<DossierDto>>> {
        return Axios.post(`${this._config.endpointUrl}api/dossiers/GetDossiers`, dto);
    }
    getCompanyAutofill(countryCode: string, vat: string): Promise<AxiosResponse<CompanyByVatNumber>> {
        return Axios.get(`${this._config.endpointUrl}api/dossiers/GetCompanyAutofil?countryCode=${countryCode}&vat=${vat}`);
    }
    createDossier(dto: CreateDossierDto): Promise<AxiosResponse<number>> {
        return Axios.post(`${this._config.endpointUrl}api/dossiers/CreateDossier`, dto);
    }
    exportToExcel(): Promise<AxiosResponse<string>> {
        return Axios.post(`${this._config.endpointUrl}api/dossiers/ExportToExcel`);
    }
   
}
export interface UpdateDossierStatus {
    dossierId: number;
    dossierStatus: DossierStatus;
}
export interface CompanyByVatNumber {
    address: string;
    hnr: string;
    postalCode: string;
    city: string;
    name: string;
    raw: string;
}
export enum ConnectedApp {
    Teamleader,
    Octopus,
    ExactOnline
}
export enum DossierStatus {
    Pending,
    Send,
    Done
}
export interface CreateForeignInvoiceDto {
    id: string,
    invoiceNumber: string,
    app: ConnectedApp
}
export interface CreateDossierDto {
    name: string;
    debName: string;
    debCountry: string;
    debEmail: string;
    debVat: string;
    debAddress: string;
    debCity: string;
    debPostalcode: string;
    debHouseNr: string;
    remarks: string;
    betwist: boolean;
    invoices: FileDto[];
    files: FileDto[];
    rappels: FileDto[],
    foreignInvoices: CreateForeignInvoiceDto[],
    totalValue: number;
    viesServiceRaw: string;
    userId?: number | undefined,
    debForeignId?: string | undefined;
    debAppId?: ConnectedApp | undefined;
    addressId?: number | undefined;
}

export interface FileDto {
    name: string;
    fileBase64: string;
}
export interface DossierDto {
    debCountry: string;
    id: number;
    name: string;
    createdByName: string;
    createdBy: number;
    debName: string;
    debEmail: string;
    debVat: string;
    debAddress: string;
    debCity: string;
    debPostalcode: string;
    debHouseNr: string;
    betwist: boolean;
    amtInvoices: number;
    invoiceNames: string;
    amtFiles: number;
    fileNames: string;
    amtRappels: number,
    rappelNames: string;
    status: DossierStatus;
    totalValue: number;
    viesServiceRaw: string;
    userId: number;
    created: Date,
    updated: Date
    dossierNr: number
}
export enum SortOrder {
    ASC = 0,
    DESC = 1
} export interface ForeignInvoice {
    id: string;
    invoiceNumber: string;
    status: string;
    amount: number;
    paid: boolean;
}
export interface ForeignDossier {
    id: number;
    description: string;
    vat: string;
}
export interface ForeignInvoiceSearchModel extends SearchModel {
    foreignCompanyId?: string;
}
export interface SearchModel {
    dossierId?: number
    app?: ConnectedApp | undefined
    search: string;
}

export interface RangeSearchModel {
    start: string;
    end: string;
}

export interface PagedRequest<T> {
    payload: T;
    skip: number;
    take: number;
    sortColumn: string;
    sortOrder: SortOrder;
}

export interface PagedData<T> {
    data: T[];
    skip: number;
    take: number;
    entityCount: number;
}
